import eventReportTable from "./event-report.json";

export const eventReports = {
	...eventReportTable,
};
